export const GLOBAL_DIALOG_EVENT_NAME = 'globalDialog';
